import { setFilter } from 'src/redux/slices/course/list'

export const handleChangeSearch = (value) => (dispatch) => {
  const payload = { key: 'courseName', value }
  dispatch(setFilter(payload))
}
